import type { Dayjs } from 'dayjs';
import type { TExpenseStatusType } from 'api/swagger';
import { createStore } from './create-store';

export interface IExpensesFilter {
  typeId?: number;
  statuses?: TExpenseStatusType[];
  endDate?: Dayjs[];
  clientId?: { value: number; label?: string };
  overdue?: boolean;
}

type TState = {
  search: string;
  filters?: IExpensesFilter;
};

type TActions = {
  setSearch: (value: string) => void;
  setFilters: (value: IExpensesFilter | undefined) => void;
};

export const useExpensesFiltersStore = createStore<TState & TActions>(
  (set) => ({
    search: '',
    filters: undefined,
    setSearch: (search: string) => set((state) => ({ ...state, search })),
    setFilters: (filters: IExpensesFilter | undefined) => set((state) => ({ ...state, filters })),
  }),
  'expenses-filters-store',
);
